import React, { useRef } from 'react';
import * as Styled from './ATextInteractive.styles';
import { ATextInteractiveSize, type ATextInteractiveProps } from './ATextInteractive.types';
import { useTracking } from '../../hooks';
import clsx from 'clsx';

const COMPONENT_NAME = 'a-web-ui-kit-ATextInteractive';
const TEST_ID = 'web-ui-kit-ATextInteractive';

const SIZE_MAP = {
  [ATextInteractiveSize.XS]: { textClassName: 't-font-xs', linkClassName: 'm-list-link-xs' },
  [ATextInteractiveSize.S]: { textClassName: 't-font-s', linkClassName: 'm-list-link-s' },
  [ATextInteractiveSize.M]: { textClassName: 't-font-m', linkClassName: 'm-list-link-m' },
};

const ATextInteractive = React.forwardRef<HTMLElement, ATextInteractiveProps>((props, ref) => {
  const {
    text,
    size = ATextInteractiveSize.M,
    className,
    trackingProperties,
    ctaLink,
    href,
    custom_click_track_value,
    preTrackVal,
    ...rest
  } = props;

  const resolvedHref = ctaLink ?? href;
  const isLink = !!resolvedHref?.trim().length;

  const defaultRef = useRef<HTMLElement>(null);
  const elementRef = (ref ?? defaultRef) as React.RefObject<HTMLElement>;

  useTracking({
    ref: elementRef,
    trackingProperties,
    custom_click_track_value,
    preTrackVal,
    text,
  });

  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      as={isLink ? 'a' : 'span'}
      ref={elementRef}
      className={clsx(SIZE_MAP[size][isLink ? 'linkClassName' : 'textClassName'], className)}
      {...rest}
      {...(isLink ? { href: resolvedHref } : {})}
    >
      {text}
    </Styled.Wrapper>
  );
});

export { ATextInteractive, ATextInteractiveSize, TEST_ID as A_TEXT_INTERACTIVE_TEST_ID };
